import RemainingBalanceModal from './RemainingBalanceModal';

export default RemainingBalanceModal;